import { render, staticRenderFns } from "./TasksAndRequestsList.vue?vue&type=template&id=3bd4ba82&scoped=true&"
import script from "./TasksAndRequestsList.vue?vue&type=script&lang=js&"
export * from "./TasksAndRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4ba82",
  null
  
)

export default component.exports